var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{attrs:{"height":"100%","width":"100%","viewBox":"0 0 100 100","preserveAspectRatio":"none"}},[_c('polygon',{staticStyle:{"fill":"currentColor","stroke":"currentColor"},attrs:{"points":"0,100 100,100 100,0 0,95"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }